import classNames from 'classnames';
import type { CSSProperties, RefObject } from 'react';
import { forwardRef } from 'react';

import { FixedComparisonTableSection } from './components/FixedComparisonTableSection';
import { SeeMoreFeaturesAccordion } from './components/SeeMoreFeaturesAccordion';
import { StickyPlansColumnHeaders } from './components/StickyPlansColumnHeaders';
import type { ComparisonTableV3Props } from './types';
import { TooltipProvider } from '../../atoms/Tooltip';

import './index.scss';

export const ComparisonTableV3 = forwardRef<HTMLDivElement, ComparisonTableV3Props>(
  (
    {
      plans,
      expansionButtonText,
      staticFeatures,
      isMWebVariantEnabled,
      children,
      onViewAllFeaturesExpand,
      onViewAllFeaturesCollapse,
    },
    ref
  ) => {
    const fixedComparisonTableSectionClassName = classNames(
      'payflow-ui',
      'comparison-table-v2',
      isMWebVariantEnabled && 'with-mweb-variant'
    );

    return (
      <TooltipProvider>
        <div
          ref={ref as RefObject<HTMLDivElement>}
          className="payflow-ui comparison-table-v3"
          style={{ '--plans-amount': plans.length.toString() } as unknown as CSSProperties}
        >
          <StickyPlansColumnHeaders plans={plans} stickyHeaderOffset={0} />
          <FixedComparisonTableSection
            className={fixedComparisonTableSectionClassName}
            group={{ id: 'static', name: 'Static Features', features: staticFeatures }}
          />
          <div className="see-more-inset">
            <SeeMoreFeaturesAccordion
              buttonText={expansionButtonText}
              onExpand={onViewAllFeaturesExpand}
              onCollapse={onViewAllFeaturesCollapse}
            >
              {children}
            </SeeMoreFeaturesAccordion>
          </div>
        </div>
      </TooltipProvider>
    );
  }
);

ComparisonTableV3.displayName = 'ComparisonTableV3';
